import React, { useState } from 'react'; // Local error state can still be useful for immediate UI feedback
import { Button, Box, Checkbox, FormControlLabel, Typography, CircularProgress } from '@mui/material';

const Step4Consents = ({ formData, handleChange, handleSubmit, prevStep, uploading, error: submissionError }) => {
  const [localError, setLocalError] = useState(''); // For errors specific to this step's validation

  const handleRegister = () => {
    setLocalError(''); // Clear local error first
    if (!formData.tosConsent) {
      setLocalError('You must agree to the Terms of Service.');
      return;
    }
    if (!formData.researchConsent) {
      setLocalError('You must consent to your data being used for research purposes.');
      return;
    }
    // If local validation passes, proceed with submission which is handled by MultiStepRegister
    handleSubmit();
  };

  return (
    <Box component="form" sx={{ mt: 3 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.tosConsent || false}
            onChange={handleChange}
            name="tosConsent" // Changed from termsOfService
            color="primary"
          />
        }
        label={
          <Typography>
            I agree to the{' '}
            <a href="/terms-of-service" target="_blank" rel="noopener noreferrer">
              Terms of Service
            </a>{' '}
            and{' '}
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </Typography>
        }
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={formData.researchConsent || false}
            onChange={handleChange}
            name="researchConsent" // Changed from researchUseConsent
            color="primary"
          />
        }
        label={
          <Typography>
            I consent to my data being used for research purposes (see{' '}
            <a href="/research-consent" target="_blank" rel="noopener noreferrer">
              Research Consent
            </a>
            ).
          </Typography>
        }
      />
      {localError && ( // Display local validation errors
        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
          {localError}
        </Typography>
      )}
      {submissionError && !uploading && ( // Display submission errors from parent
        <Typography color="error" variant="body2" sx={{ mt: 1 }}>
          {submissionError}
        </Typography>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3, mb: 2 }}>
        <Button variant="outlined" onClick={prevStep} disabled={uploading}>
          Previous
        </Button>
        <Button variant="contained" color="primary" onClick={handleRegister} disabled={uploading}>
          {uploading ? <CircularProgress size={24} /> : 'Submit'}
        </Button>
      </Box>
    </Box>
  );
};

export default Step4Consents;
